import React, { useCallback, useState } from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, RawButton, Text } from '@common-fe/common-fe';

interface Props {
  testId: string;
  title: string;
  children: React.ReactNode;
}
const InfoBlock: React.FC<Props> = ({testId, title, children }) => {
  const [isExpanded, setExpanded] = useState(false);
  const handleToggle = useCallback(() => {
    setExpanded(!isExpanded);
  }, [isExpanded]);
  return (
    <RawButton data-testid={`toggle_info-block_button_${testId}`} onClick={handleToggle}>
      <Box 
        direction="column" 
        round="container1Round"
        background={isExpanded ? 'border1': 'canvas'}
        border={{size: 'small', color:'border1'}}
        pad={{ vertical: 'm', horizontal: 'l' }}
      >
        <Box direction='row'>
          {isExpanded ? (
            <ChevronUpIcon color="iconPrimary" size="24px" />
          ) : (
            <ChevronDownIcon color="iconPrimary" size="24px" />
          )}
          
          
          <Text   data-testid={`toggle_info-block_title_${testId}`} weight={400} size="large">{title}</Text>
        </Box>
        {
          isExpanded && (
            <Box  margin={{top: 'xs'}}>
              <Text   data-testid={`toggle_info-block_text_${testId}`} weight={400} size="medium">{children}</Text>
            </Box>
          )
        }
      </Box>
    </RawButton>
  );
};

export default InfoBlock;
